import { Component, OnInit, ViewChild, Input, ViewEncapsulation, NgZone, Output, EventEmitter, AfterViewInit}            from '@angular/core';
import { CanvasWhiteboardComponent, CanvasWhiteboardShapeService, CanvasWhiteboardOptions, CanvasWhiteboardUpdate } from 'ng2-canvas-whiteboard';
import { getPaintBucketShapeClass }     from './shapes/paint-bucket.shape';
import { Globals } from 'projects/shared/models/Globals';
import { LoadedEntry } from '../../../models/coloring-game.models';
import { MatDialog } from '@angular/material';
import { ColoringGameDialogComponent } from '../coloring-game-dialog/coloring-game-dialog.component';
declare var $: any;
@Component({
  selector: 'app-coloring-game',
  templateUrl: './coloring-game.component.html',
  styleUrls: ['./coloring-game.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ColoringGameComponent implements OnInit, AfterViewInit {
  
  unsubscribeComponentResize(): any {
    let component = this.canvasWhiteboard as any;
    component._unsubscribe(component._resizeSubscription);
  }
  @ViewChild('canvasWhiteboard') canvasWhiteboard : CanvasWhiteboardComponent;
  canvas            : HTMLCanvasElement;
  canvasContext     : CanvasRenderingContext2D;
  incompleteCanvas  : HTMLCanvasElement;
  globals=Globals;
  canvasOptions: CanvasWhiteboardOptions;
  
  @Input() canvasOriginalHeight : number = 1000;
  @Input() canvasOriginalWidth  : number = 1000;
  @Input() imageMargin          : number = 0;
  
  @Input('fillColor')   initialFillColor    : string = "rgba(0,0,0,255)";
  @Input('strokeColor') initialStrokeColor: string = "rgba(0,0,0,255)";
  @Output() output: EventEmitter<number> = new EventEmitter<number>();

  @Input() entry: LoadedEntry = new LoadedEntry();
 lineWidth: number = 5;

  constructor(private _canvasWhiteboardShapeService: CanvasWhiteboardShapeService, private _ngZone: NgZone, public dialog : MatDialog) {
    window['angularComponentRef'] = { component: this, zone: _ngZone };
  }
  inputRangEmiter() {
    this.output.emit(this.lineWidth);
  }
  changeLineWidth(value) {
    this.lineWidth = Number(value);
    this.inputRangEmiter();
  }

  lineWidthChanged($event : Event) { this.lineWidth = parseInt(($event.target as HTMLInputElement).value); }
  ngOnInit(){
    console.log(this.canvasWhiteboard);
    this.canvas = this.canvasWhiteboard.canvas.nativeElement;
    this.canvasContext = this.canvas.getContext('2d');
    this.incompleteCanvas = (this.canvasWhiteboard as any)._incompleteShapesCanvas.nativeElement;

    this.resizeCanvases(this.canvasOriginalWidth, this.canvasOriginalHeight);

    let PaintBucketClass = getPaintBucketShapeClass(this.canvasContext, this.canvasWhiteboard);
    this._canvasWhiteboardShapeService.registerShape(PaintBucketClass);

    this.canvasWhiteboard.setDrawingEnabled(true);
    this.canvasOptions = {  
        drawButtonEnabled: false,
        drawButtonClass: "drawButtonClass",
        drawButtonText: "Draw",
        drawingEnabled: true,
    
        clearButtonEnabled: false,
        clearButtonClass: "icon-cw-clear",
        clearButtonText: Globals.ViewLocalizedResources.Clear,
    
        // fillText:Globals.ViewLocalizedResources.Fill,
        // strockText:Globals.ViewLocalizedResources.Strock,
        
        undoButtonText: Globals.ViewLocalizedResources.Undo,
        undoButtonEnabled: true,
        undoButtonClass: "icon-cw-undo",
      
        redoButtonText: Globals.ViewLocalizedResources.Redo,
        redoButtonEnabled: true,
        redoButtonClass: "icon-cw-redo",
        
        colorPickerEnabled: true,
        showFillColorPicker:false,
        showStrokeColorPicker:false,

        shapeSelectorEnabled: true,
        showShapeSelector:true,

        saveDataButtonEnabled: true,
        saveDataButtonText: Globals.ViewLocalizedResources.Save,
        saveDataButtonClass: "icon-cw-save",
    
        shouldDownloadDrawing: true,
  
        imageUrl: this.entry.blackAndWhiteImage,
        startingColor:"rgba(0,0,0,255)",
        fillColor:"rgba(255,255,255,255)"
      };    
    
     $(document).on('click','canvas-whiteboard-shape-preview',function(){
       $('canvas-whiteboard-shape-preview').removeClass("active");
       $(this).addClass("active");
     })
  }

  ngAfterViewInit(){ }

  drawImage = (entry : LoadedEntry, clearCanvas = true) =>  {
    clearCanvas && this.canvasWhiteboard.clearCanvas();
  }

  resizeCanvases(width: number, height: number): any {
    this.canvas.height = this.incompleteCanvas.height = height;
    this.canvas.width  = this.incompleteCanvas.width  = width;
  }

  Close(){
    location.reload();
  }

  onCanvasClear(){
    const dialogRef = this.dialog.open(ColoringGameDialogComponent, {
      width: '540px',
      data: { 
        saveFn : _ => this.canvasWhiteboard.saveLocal(),
        clearFn: _=> this.canvasWhiteboard.clearCanvas()
      }
    });
  }

}
